// Contact Information Constants

export const CONTACT_INFO = {
  // Company Details
  company: {
    name: 'NiveshRight',
    tagline: 'Your Trusted Investment Partner',
  },

  // AMFI Registration
  amfi: {
    arn: '341940', // AMFI Registration Number
    certified: true,
  },

  contact_person: {
    full_name: 'Vishal Telangre',
    short_name: 'Vishal',
    designation: 'AMFI Certified Mutual Fund Distributor',
    email: 'vishal@niveshright.com',
    phone: '+91 80877 29277',
    whatsapp: '918087729277',
  },

  // Phone Numbers
  phone: {
    primary: '+91 80877 29277',
    whatsapp: '918087729277', // Format: country code + number (no + or spaces)
    display: '+91 80877 29277', // For display purposes
  },

  // Email Addresses
  email: {
    general: 'hi@niveshright.com',
    support: 'support@niveshright.com',
    legal: 'legal@niveshright.com',
    privacy: 'privacy@niveshright.com',
  },

  // Address Information
  address: {
    street: 'Plot 72, Gangotri Vihar, Nakshatrawadi',
    area: 'Nakshatrawadi',
    city: 'Chatrapati Sambhaji Nagar',
    state: 'Maharashtra',
    pincode: '431011',
    country: 'India',
    // Formatted address for display
    full: 'Plot 72, Gangotri Vihar, Nakshatrawadi, Chatrapati Sambhaji Nagar, Maharashtra, India - 431011',
    // Short address for cards/footers
    short: 'Chatrapati Sambhaji Nagar, Maharashtra, India',
    mapLink: 'https://maps.app.goo.gl/SM4zpBR8ScQc1LTD7',
  },

  // Social Media & Web
  social: {
    website: 'https://niveshright.com',
    // Add other social media links as needed
  },

  // Business Hours
  hours: {
    weekdays: '9:00 AM - 6:00 PM',
    timezone: 'IST (Indian Standard Time)',
  },
} as const;

// Export individual constants for convenience
export const { amfi, phone, email, address, social } = CONTACT_INFO;

// Validation regex patterns
export const VALIDATION = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^[+]?[1-9][\d]{0,15}$/,
} as const;
